import * as React from 'react';

import '@app/scss/components/bannerInner.scss';

interface BannerProps {
	message: string;
	bannerClass?: string;
}

const exclamationIcon = require('@app/images/exclamation_circle.svg');

const BannerInner: React.FC<BannerProps> = ({ message, bannerClass = 'exclamation' }) => {
	return (
		<article className={`banner-inner banner-inner--${bannerClass}`}>
			<h5 className="banner-inner__title"><img className="banner-inner__icon exclamation-icon" src={exclamationIcon} alt=""/> Notice:</h5>
			<p className="banner-inner__text" dangerouslySetInnerHTML={{__html: message || ''}} />
		</article>
	);
};

export default BannerInner;